

@if (message) {

  @if (message.channelContent.attachments?.length) {
    <div class="attachment-container mt-2">
      @for (attachment of message.channelContent.attachments; track attachment) {
        <span (click)="onAttachment(attachment)" class="attachment-box" [attr.data-test]="'message-attachment-' + attachment.filename + '-' + attachment.size">
          📎 {{ attachment.filename }}
          @if (attachment.size) {
            ({{ (attachment.size / 1024).toFixed(2) }} KB)
          }
        </span>
      }
    </div>
  }
}